"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldsToIndex = exports.mapAggregateTypeToAggregateTable = exports.getPropertyDefinitions = exports.hasProperties = exports.findAggregateConfig = exports.getFieldsWithRelationshipType = exports.extractPropertiesToIncludeInFullText = exports.isRelationshipType = void 0;
const isRelationshipType = (propType) => {
    return propType.relation !== undefined;
};
exports.isRelationshipType = isRelationshipType;
const extractPropertiesToIncludeInFullText = (aggregate) => {
    return Object.keys(aggregate.properties)
        .filter(val => {
        return aggregate.properties[val].includeInFullText && !(0, exports.isRelationshipType)(aggregate.properties[val]);
    })
        .concat(['label']);
};
exports.extractPropertiesToIncludeInFullText = extractPropertiesToIncludeInFullText;
const getFieldsWithRelationshipType = (aggregate) => {
    return Object.keys(aggregate.properties).filter(propKey => {
        const prop = aggregate.properties[propKey];
        return (0, exports.isRelationshipType)(prop) && prop.relation === 'ONE-TO-ONE';
    });
};
exports.getFieldsWithRelationshipType = getFieldsWithRelationshipType;
const findAggregateConfig = (aggregateConfigs, type) => {
    return aggregateConfigs.find(agg => agg.typeName === type);
};
exports.findAggregateConfig = findAggregateConfig;
const hasProperties = (aggregate, properties) => {
    properties.forEach(property => {
        if (!Object.keys(aggregate.properties).includes(property))
            return false;
    });
    return true;
};
exports.hasProperties = hasProperties;
const getPropertyDefinitions = (aggregateDefinition) => Object.keys(aggregateDefinition.properties).map((prop) => {
    const relationProps = aggregateDefinition.properties[prop];
    return {
        field: prop,
        label: relationProps.label,
        uiType: 'uiType' in relationProps ? relationProps.uiType || relationProps.type : relationProps.type,
        type: relationProps.type,
        validOptions: relationProps.validOptions,
        isRelationship: 'relation' in relationProps,
        isEditable: !!relationProps.editable,
        foreignColumn: 'foreignColumn' in relationProps ? relationProps.foreignColumn : undefined,
        isFilterable: relationProps.filterable,
        relationshipType: 'relation' in relationProps ? relationProps.relation : undefined,
    };
});
exports.getPropertyDefinitions = getPropertyDefinitions;
const mapAggregateTypeToAggregateTable = (aggregateConfigs, type) => {
    const aggregateConfig = (0, exports.findAggregateConfig)(aggregateConfigs, type);
    return (aggregateConfig === null || aggregateConfig === void 0 ? void 0 : aggregateConfig.objectStore.table) || '';
};
exports.mapAggregateTypeToAggregateTable = mapAggregateTypeToAggregateTable;
const getFieldsToIndex = (aggregate) => {
    return Object.keys(aggregate.properties).filter(propKey => {
        const prop = aggregate.properties[propKey];
        return ((0, exports.isRelationshipType)(prop) && prop.relation === 'ONE-TO-ONE') || (!(0, exports.isRelationshipType)(prop) && prop.indexed);
    });
};
exports.getFieldsToIndex = getFieldsToIndex;
//# sourceMappingURL=utils.js.map